<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pt15 pb15">
            <hos_search_from @queryData="queryData" ref="serarch"></hos_search_from>
            <hos_tab_toggle v-model="tab" :list="tabList"></hos_tab_toggle>
            <div class="mt15">
                <el-table border size="mini" :data="tableList" :header-cell-style="{backgroundColor:'#fafafa'}">
                    <el-table-column label="状态" align="center" prop="referralStatus" :formatter="formateReferralStatus"
                                     :key=Math.random()></el-table-column>
                    <el-table-column :label="$route.params.type == 'check' ? '安排日期' : '安排手术日期'" align="center"
                                     prop="acceptTime" :formatter="formateTime" v-if="tab == 2"
                                     :key=Math.random()></el-table-column>
                    <el-table-column label="编号" align="center" prop="referralOrderNo"
                                     :key=Math.random()></el-table-column>
                    <el-table-column label="姓名" align="center" prop="patName" :key=Math.random()></el-table-column>
                    <el-table-column label="性别" align="center" prop="patGender" :formatter="formateSex"
                                     :key=Math.random()></el-table-column>
                    <el-table-column label="年龄" align="center" prop="patAge" :key=Math.random()></el-table-column>
                    <el-table-column label="申请时间" align="center" prop="createTime" :formatter="formateTime"
                                     :key=Math.random()></el-table-column>
                    <el-table-column label="申请医院" align="center" prop="initHosName" v-if="pageType == 'accept'"
                                     :key=Math.random()></el-table-column>
                    <el-table-column label="申请医生" align="center" prop="initDocName"
                                     :key=Math.random()></el-table-column>
                    <el-table-column label="预约医院" align="center" prop="hopeHosName"
                                     :key=Math.random()></el-table-column>
                    <el-table-column :label="$route.params.type == 'check' ? '预约项目' : '预约手术项目'" align="center"
                                     prop="projectName" :key=Math.random()></el-table-column>
                    <el-table-column :label="$route.params.type == 'check' ? '预约转诊日期' : '预约手术日期'" align="center"
                                     prop="hopeTime" :formatter="formateTime" :key=Math.random()></el-table-column>
                    <el-table-column label="操作" align="center" fixed="right" width="160" :key=Math.random()>
                        <template slot-scope="{row}">
                            <el-button size="mini" @click="gpPage('会诊单',row)" v-if="tab == 2">转诊单</el-button>
                            <el-button size="mini" @click="gpPage('详情',row)" type="primary">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pt15" style="text-align: center">
                <el-pagination
                        @current-change="pageChange"
                        :page-size="page.pageSize"
                        :current-page="page.pageNum"
                        layout="total, prev, pager, next, jumper"
                        :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import Breadcrumb from "../../components/common/Breadcrumb";
  import hos_search_from from "../../components/hos/hos-search-from"
  import hos_tab_toggle from "../../components/hos/hos-tab-toggle"
  import {launch_arr, accept_arr, timeFormat} from "../../lib/hos/until";
  import {initMixin} from "../../lib/mixins/hosInit"
  import {acceptMixin} from "../../lib/mixins/hosAccept"

  export default {
    name: "list",
    components: {
      Breadcrumb, hos_search_from, hos_tab_toggle
    },
    mixins: [initMixin, acceptMixin],
    data() {
      return {
        pages: [],
        tab: 1,
        //转诊状态：-2- 已拒绝 -1-已取消 2-待审核 4-已完成
        tabObj: {
          '1': ['2'],
          '2': ['4'],
          '3': ['-2', '-1']
        },
        tabList: [],
        tableList: [],
        page: {
          pageSize: 20,
          pageNum: 1,
          total: 0
        },
        pageType: null,//申请页面 -- init    安排页面 -- accept
        pageName: null,// 检查转诊 --- check  日间手术转诊 -- surgery
      }
    },
    methods: {
      pageChange(num) {
        this.page.pageNum = num;
        this.queryData(true);
      },
      //跳转方法
      gpPage(type, row) {
        let {id} = row;
        if (type == '详情') {
          this.$router.push({
            path: `/main/referral/hos/${this.$route.params.type}/detail/${id}`, query: {
              from: this.pageType//从那个列表页跳转的
            }
          });
        } else {
          this.$router.push(`/main/referral/hos/${this.$route.params.type}/report/${id}`);
        }
      },
      //判断页面类型
      getPageType() {
        const {type, title} = this.$route.meta;
        this.pageName = this.$route.params.type;
        this.pageType = type;
        this.tabList = type == 'init' ? launch_arr : accept_arr;
        this.pages = [this.pageName == 'check' ? "检查转诊" : "日间手术转诊"].concat(title);
      },
      //查询数据
      async queryData(f = false) {
        let form = this.$refs['serarch'].getForm();
        if (!f) this.page.pageNum = 1; //重置页码
        form.referralStatusList = this.tabObj[this.tab];
        form.referralType = this.pageName == 'check' ? "检查转诊" : "日间手术转诊";
        form.pageSize = this.page.pageSize;
        form.pageNum = this.page.pageNum;
        let start = form.startTime.substring(0, 4) + form.startTime.substring(5, 7) + form.startTime.substring(8, 10)
        let end = form.endTime.substring(0, 4) + form.endTime.substring(5, 7) + form.endTime.substring(8, 10)

        if (end < start) {
          this.$message.error('请合理选择时间范围！')
          return
        }
        if (this.pageType == 'init') {
          //发起方
          const {list, page} = await this.queryInitList(form);
          this.tableList = list;
          this.page.total = page.total;
        } else {
          //收到方
          const {list, page} = await this.queryAcceptList(form);
          this.tableList = list;
          this.page.total = page.total;
        }
      },
      //性别的格式化函数
      formateSex(row, column, cellValue) {
        return cellValue == 'F' ? '女' : '男';
      },
      //时间的格式化函数
      formateTime(row, column, cellValue) {
        return timeFormat(cellValue, '%Y-%m-%d %H:%M');
      },
      //单子状态转换
      formateReferralStatus(row, column, cellValue) {
        switch (cellValue) {
          case "WAIT_EXAMINE" :
            return "待审核";
          case "FINSH" :
            return "已安排";
          case "REFUSED" :
            return "拒绝转诊";
          case "CANCEL" :
            return "取消申请";
        }
      }
    },
    watch: {
      $route() {
        this.getPageType();
        this.queryData();
      },
      tab() {
        this.queryData();
      }
    },
    created() {
      this.getPageType();
    }
  }
</script>

<style scoped>

</style>